import { fireAndForget } from './fireAndForget'

/** Copies text to the clipboard; a refused write (no focus, denied permission) is logged. */
export const copyToClipboard = (text: string) =>
  fireAndForget('[Clipboard] copy', () => navigator.clipboard.writeText(text))
